var map = {
	"./PassionIT-green-p-200.jpeg": 29461,
	"./genai343.jpg": 67581,
	"./landingpage-theme1.jpg": 96347,
	"./simplify343.jpg": 92338,
	"./upskilling343.jpg": 18954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71766;